export const useOptions = () => {
    //* 插件
    const i18n = useI18n();
    return {
        name: <{ [name: string]: string }>{
            "9606": i18n.t("HumanGene"),
            "10090": i18n.t("MouseGene"),
            "10116": i18n.t("RatGene"),
        },

        selectors: [
            { species: 9606, value: "", show: false, data: [] },
            { species: 10090, value: "", show: false, data: [] },
            { species: 10116, value: "", show: false, data: [] },
        ],
    };
};
